import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import { RuleSet } from 'styled-components';
import {
  Divider,
  NewSearchEmptyContainer,
  NewSearchEmptyLink,
  NewSearchEmptyText,
  NewSearchEmptyTitle
} from './styled';

interface NewSearchEmptyProps {
  onClickHandler?: () => void;
  linkText?: string;
  emptyText?: string;
  width?: number;
  height?: number;
  emptyTextStyles?: RuleSet<object>;
}

export const NewSearchEmpty = ({
  onClickHandler,
  linkText,
  emptyText,
  width = 317,
  height = 270,
  emptyTextStyles
}: NewSearchEmptyProps) => {
  const { t } = useTranslation();

  return (
    <>
      {linkText && <Divider />}
      <NewSearchEmptyContainer>
        <Image
          width={width}
          height={height}
          src="/static/images/new_ad/icons/icon-not-found.png"
          data-cy="empty-icon"
          alt=""
        />

        {linkText && (
          <NewSearchEmptyTitle data-cy="empty-title">
            {t('search.nothing_found')}
          </NewSearchEmptyTitle>
        )}

        {linkText && (
          <NewSearchEmptyLink
            href="#"
            onClick={onClickHandler}
            data-cy="empty-link"
          >
            {linkText}
          </NewSearchEmptyLink>
        )}

        {emptyText && (
          <NewSearchEmptyText
            tag="body_1"
            data-cy="city_empty_text"
            styles={emptyTextStyles}
          >
            {emptyText}
          </NewSearchEmptyText>
        )}
      </NewSearchEmptyContainer>
    </>
  );
};
